import AdvocateJuberDetails from '../../components/about/advocates-details/juber';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateJuberDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | S. A. Juber Hussain'>
      <NavigationMenu active='about' />
      <PageHeader
        title='S. A. Juber Hussain'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateJuberDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateJuberDetailsPage;
